"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
var eventValidation_service_1 = require("./eventValidation.service");
var timber_service_1 = require("./timber.service");
var consts_1 = require("./consts");
var uuidv4 = require('uuid').v4;
var EventBus = /** @class */ (function () {
    function EventBus(loggingEndpoint, commonSectionSchemas) {
        this.initContextEventName = 'init-context';
        this.sessionUpdatedEventName = 'session-updated';
        this._region = '';
        this._sessionId = '';
        this.validChannelName = [consts_1.ChannelName.platformChannel, consts_1.ChannelName.applicationChannel];
        this.subscriptions = new Map();
        this.timberService = new timber_service_1.TimberService(loggingEndpoint);
        this.eventValidationService = new eventValidation_service_1.EventValidationService(this.timberService, commonSectionSchemas);
    }
    Object.defineProperty(EventBus.prototype, "region", {
        get: function () {
            return this._region;
        },
        set: function (region) {
            this._region = region;
            this.timberService.info("Region was set successfully with ".concat(region), { module: 'EventBus' });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventBus.prototype, "sessionId", {
        get: function () {
            return this._sessionId;
        },
        set: function (sessionId) {
            this._sessionId = sessionId;
            this.timberService.info("Session id was set successfully with ".concat(sessionId), { module: 'EventBus' });
        },
        enumerable: false,
        configurable: true
    });
    EventBus.prototype.on = function (channelName, callbackAppId, callbackFunc) {
        var logParams = { module: 'on', extendedParameters: { channelName: channelName, callbackAppId: callbackAppId, sessionId: this._sessionId } };
        var subscriptionSucceeded = false;
        if (this.validChannelName.includes(channelName)) {
            if (this.subscriptions.has(channelName)) {
                var channelMap = this.subscriptions.get(channelName);
                if (channelMap === null || channelMap === void 0 ? void 0 : channelMap.get(callbackAppId)) {
                    this.timberService.error(callbackAppId + ' already subscribed to ' + channelName, logParams);
                }
                else {
                    channelMap === null || channelMap === void 0 ? void 0 : channelMap.set(callbackAppId, callbackFunc);
                    subscriptionSucceeded = true;
                    this.timberService.info('Application subscribed successfully', logParams);
                }
            }
            else {
                if (typeof window !== 'undefined') {
                    var newChannelMap = new Map();
                    newChannelMap.set(callbackAppId, callbackFunc);
                    this.subscriptions.set(channelName, newChannelMap);
                    window.addEventListener(channelName, this.handleEvent.bind(this, channelName));
                    this.timberService.info('Application subscribed successfully', logParams);
                    subscriptionSucceeded = true;
                }
                else {
                    this.timberService.warn('Subscribing application ' + callbackAppId + ' to ' + channelName + ' failed because you are not running inside a browser', logParams);
                }
            }
        }
        else {
            this.timberService.error('Channel ' + channelName + ' is not supported.', logParams);
        }
        return subscriptionSucceeded;
    };
    EventBus.prototype.emit = function (channelName, publisherAppId, eventName, eventSchema, eventId, targetApplications, eventPayload) {
        var logParams = { module: 'emit', extendedParameters: { eventId: eventId, channelName: channelName, publisherAppId: publisherAppId, eventName: eventName, sessionId: this._sessionId } };
        if (this.validChannelName.includes(channelName)) {
            this.updatePrivateFields(eventName, eventPayload);
            logParams.extendedParameters.sessionId = this.sessionId;
            var eventMessage = this.buildEvent(publisherAppId, eventName, eventId, targetApplications, eventPayload);
            var isEventValid = this.eventValidationService.validateEventSchema(eventName, eventMessage, eventId, eventSchema);
            if (isEventValid) {
                var event = new CustomEvent(channelName, { detail: eventMessage });
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(event);
                    this.timberService.info('Event was published successfully', logParams);
                    return true;
                }
                else {
                    this.timberService.warn('Publishing event ' + eventId + ' to channel ' + channelName + ' was failed because you are not running inside a browser', logParams);
                    return false;
                }
            }
        }
        else {
            this.timberService.error('Channel ' + channelName + ' is not supported.', logParams);
        }
        return false;
    };
    EventBus.prototype.unsubscribe = function (channelName, appIdToUnsubscribe) {
        var _a;
        var logParams = { module: 'unsubscribe', extendedParameters: { channelName: channelName, appIdToUnsubscribe: appIdToUnsubscribe, sessionId: this._sessionId } };
        (_a = this.subscriptions.get(channelName)) === null || _a === void 0 ? void 0 : _a.delete(appIdToUnsubscribe);
        this.timberService.info('Unsubscribing app successfully', logParams);
    };
    EventBus.prototype.generateEventId = function () {
        var logParams = { module: 'generateEventId' };
        var eventId = uuidv4();
        this.timberService.info('Generating event', __assign(__assign({}, logParams), { extendedParameters: { eventId: eventId, sessionId: this._sessionId } }));
        return eventId;
    };
    EventBus.prototype.updatePrivateFields = function (eventName, eventPayload) {
        var _a, _b;
        if (eventName === this.initContextEventName) {
            this.sessionId = (_a = eventPayload.session) === null || _a === void 0 ? void 0 : _a.sessionId;
            this.region = (_b = eventPayload.bizCtx) === null || _b === void 0 ? void 0 : _b.region;
        }
        else if (eventName === this.sessionUpdatedEventName) {
            this.sessionId = eventPayload.sessionId;
        }
    };
    EventBus.prototype.handleEvent = function (channelName, event) {
        var e_1, _a;
        var _this = this;
        var logParams = { module: 'handleEvent' };
        this.updatePrivateFields(event.detail.eventHeader.eventName, event.detail.data);
        if (event.detail.eventHeader.subscribers.includes('*')) {
            var appsCallbackMap = this.subscriptions.get(channelName);
            if (appsCallbackMap) {
                try {
                    for (var appsCallbackMap_1 = __values(appsCallbackMap), appsCallbackMap_1_1 = appsCallbackMap_1.next(); !appsCallbackMap_1_1.done; appsCallbackMap_1_1 = appsCallbackMap_1.next()) {
                        var _b = __read(appsCallbackMap_1_1.value, 2), subscriberAppId = _b[0], callbackFunc = _b[1];
                        if (subscriberAppId !== event.detail.eventHeader.publisher) {
                            callbackFunc.call(undefined, event.detail);
                            this.timberService.info("Trigger ".concat(event.detail.eventHeader.eventName, " callback for ").concat(subscriberAppId), __assign(__assign({}, logParams), { extendedParameters: { subscriberAppId: subscriberAppId, sessionId: this.sessionId } }));
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (appsCallbackMap_1_1 && !appsCallbackMap_1_1.done && (_a = appsCallbackMap_1.return)) _a.call(appsCallbackMap_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        else {
            event.detail.eventHeader.subscribers.forEach(function (subscriberAppId) {
                var _a;
                var appCallback = (_a = _this.subscriptions.get(channelName)) === null || _a === void 0 ? void 0 : _a.get(subscriberAppId);
                if (appCallback) {
                    appCallback.call(undefined, event.detail);
                    _this.timberService.info("Trigger ".concat(event.detail.eventHeader.eventName, " callback for ").concat(subscriberAppId), __assign(__assign({}, logParams), { extendedParameters: { subscriberAppId: subscriberAppId, sessionId: _this.sessionId } }));
                }
            });
        }
    };
    EventBus.prototype.buildEvent = function (sourceAppId, eventName, eventId, targetApplications, eventPayload) {
        if (eventPayload) {
            return {
                "systemHeader": {
                    "region": this.region,
                    "datetime": Date.now(),
                    "sessionId": this.sessionId,
                    "schemaVersion": '1.0.0',
                    "dataVersion": '1.0.0'
                },
                "eventHeader": {
                    "eventId": eventId,
                    "eventName": eventName,
                    "publisher": sourceAppId,
                    "subscribers": targetApplications,
                },
                "data": eventPayload
            };
        }
        else {
            return {
                "systemHeader": {
                    "region": this.region,
                    "datetime": Date.now(),
                    "sessionId": this.sessionId,
                    "schemaVersion": '1.0.0',
                    "dataVersion": '1.0.0'
                },
                "eventHeader": {
                    "eventId": eventId,
                    "eventName": eventName,
                    "publisher": sourceAppId,
                    "subscribers": targetApplications,
                }
            };
        }
    };
    return EventBus;
}());
exports.EventBus = EventBus;
